import React from "react";

import { Toaster } from "react-hot-toast";

export const AppDataProvider = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            {children} <Toaster position="top-center" />
        </>
    );
};
